import api from '../services/api';
import apiWithJwt from '../services/apiWithJwt';
import { types } from '../store/constants/types';


export const emptyReduxPayments = () => {
  return dispatch => {
    dispatch({type : types.CREATE_PAYMENT_REQUEST_DATA_FAILED, payload : []})
    dispatch({type : types.GET_ALL_TRANSACTION_FAILED, payload : []})
    dispatch({type : types.GET_TRANSACTIONS_BY_USER_ID_FAILED, payload : []})
    dispatch({type : types.GET_TRANSACTION_FAILED, payload : []})
    dispatch({type : types.CREATE_PAYMENT_REQUEST_DATA_SUCCESS, payload : []})
    dispatch({type : types.GET_ALL_TRANSACTION_SUCCESS, payload : []})
    dispatch({type : types.GET_TRANSACTIONS_BY_USER_ID_SUCCESS, payload : []})
    dispatch({type : types.GET_TRANSACTION_SUCCESS, payload : []})
  }
}

export const getAllTransactions = (perPage = 10, currentPage = 1) => {

  let queryParams = `?perPage=${perPage}&currentPage=${currentPage}`;
  
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/payments/transactions'+queryParams)
      .then((response) => {
        dispatch({ type: types.GET_ALL_TRANSACTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_ALL_TRANSACTION_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetAllSubscriptions = () => {
  return dispatch => {
    dispatch({type : types.GET_ALL_TRANSACTION_SUCCESS, payload : []})
}};

export const getTransactionById = (id) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/payments/transaction/'+id)
      .then((response) => {
        dispatch({ type: types.GET_TRANSACTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_TRANSACTION_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetTransactionById = () => {
  return dispatch => {
    dispatch({type : types.GET_TRANSACTION_SUCCESS, payload : []})
}};


export const getTransactionByUserId = (id) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/payments/transaction/user/'+id)
      .then((response) => {
        dispatch({ type: types.GET_TRANSACTIONS_BY_USER_ID_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_TRANSACTIONS_BY_USER_ID_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetTransactionByUserId = () => {
  return dispatch => {
    dispatch({type : types.GET_TRANSACTIONS_BY_USER_ID_SUCCESS, payload : []})
}};


export const createPaymentRequestData = (userSubscriptionId = 0) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/payu/createPaymentRequestData/'+userSubscriptionId)
      .then((response) => {
        dispatch({ type: types.CREATE_PAYMENT_REQUEST_DATA_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.CREATE_PAYMENT_REQUEST_DATA_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetCreatePaymentRequestData = () => {
  return dispatch => {
    dispatch({type : types.CREATE_PAYMENT_REQUEST_DATA_SUCCESS, payload : []})
}};


export const sendWhatsAppPaymentLink = (userSubscriptionId) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/payments/sendWhatsAppPaymentlink/'+userSubscriptionId)
      .then((response) => {
        dispatch({ type: types.SEND_WHATSAPP_PAYMENT_LINK_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.SEND_WHATSAPP_PAYMENT_LINK_FAILED, payload: (error.response ? error.response.data : { statusCode: 500, message: error.message })});
      });
  };
};

export const resetSendWhatsAppPaymentLink = () => {
  return dispatch => {
    dispatch({type : types.SEND_WHATSAPP_PAYMENT_LINK_SUCCESS, payload : []})
    dispatch({type : types.SEND_WHATSAPP_PAYMENT_LINK_FAILED, payload : ''})
}};
